/**
 * TanStack Query hooks for `igaming-geographic-jurisdiction-block-geo-exclusio`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingGeographicJurisdictionBlockGeoExclusioQueryKeys,
	type CreateIgamingGeographicJurisdictionBlockGeoExclusioBody,
	type ListIgamingGeographicJurisdictionBlockGeoExclusioResponse,
	type IgamingGeographicJurisdictionBlockGeoExclusioRow,
} from "./api";

export function useIgamingGeographicJurisdictionBlockGeoExclusioList(): UseQueryResult<ListIgamingGeographicJurisdictionBlockGeoExclusioResponse, Error> {
	return useQuery({
		queryKey: igamingGeographicJurisdictionBlockGeoExclusioQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingGeographicJurisdictionBlockGeoExclusioCreate(): UseMutationResult<IgamingGeographicJurisdictionBlockGeoExclusioRow, Error, CreateIgamingGeographicJurisdictionBlockGeoExclusioBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingGeographicJurisdictionBlockGeoExclusioQueryKeys.all });
		},
	});
}

export function useIgamingGeographicJurisdictionBlockGeoExclusioDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingGeographicJurisdictionBlockGeoExclusioQueryKeys.all });
		},
	});
}
